(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$localStorage'];

    function NavbarController ($scope, $state, Auth, Principal, ProfileService, LoginService, $localStorage) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        /*ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = false;
            vm.swaggerDisabled = true;
        });*/

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        $scope.$watch(function () {
            return $localStorage.projectinfo ? $localStorage.projectinfo.steinexpo : false;
        }, function (steinexpo) {
            vm.steinexpo = steinexpo;
        });

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home', {}, {reload: true, notify: true});
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();
